import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "border-b-2 border-capPurple flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, " Contract Info ", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "bg-white p-8" }
const _hoisted_6 = { class: "bg-white p-8" }
const _hoisted_7 = { class: "bg-white p-8" }

import { ref, computed, onMounted } from 'vue'
    import ContractInfo from './ContractInfo.vue'
    import ContractPayments from './ContractPayments.vue'
    import ContractClaims from './ContractClaims.vue'
    import store from '@/store'
    import SharedAPI from '@/api/SharedAPI'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ContractDetail',
  props: {id: String},
  setup(__props) {

const props = __props

    

    const isLoading = ref(false)
    const user = computed(() => store.state.user)
    const contract = computed(() => store.state.contract)
    const activeTab = ref<'contract' | 'payments' | 'claims'>('contract')

    onMounted(async () => {
        try {
            isLoading.value = true
            await getContractDetails()
            await getPaymentDetails()
            await getClaimDetails()
        }
        catch (error: any) {
            console.error(error)
        }
        finally {
            isLoading.value = false
        }
    })

    function handleTabs(tab: 'contract' | 'payments' | 'claims') {
        activeTab.value = tab
    }

    async function getContractDetails() {
        try {
            const params = [{ '__kptID': props.id }]
            const res = await SharedAPI.performFind(params, 'contract_detail', false, 'set_globals', props.id)
            store.commit('setContractDetails', res.response.data[0].fieldData)
        }
        catch (error: any) {
            console.error(error)
        }
    }

    async function getPaymentDetails() {
        const params = [{
            'payment__CONTRACT__contractID::_kftContactID': user.value.kptID,
            '_kftContractID': '*',
            '_kftClaimID': '='
        }]
        const sort = [{fieldName: "date", sortOrder: "descend"}]

        try {
            const res = await SharedAPI.performFind(params, 'payment', sort)

            let payments = []

            res.response.data.forEach(payment => {
                payments.push(payment.fieldData)
            })


            store.commit('setPaymentList', payments.filter(p => p.zctContractNumberDisplay === contract.value.contractNumberDisplay))
        }
        catch (error: any) {
            console.error(error)
        }
    }

    async function getClaimDetails() {
        const params: any = [{
            'claim__CONTRACT__contractID::_kftContactID': user.value.kptID,
            'isActive': 1
        }]
        const sort: any = [{fieldName: "claimDate", sortOrder: "descend"}]

        try {
            const res = await SharedAPI.performFind(params, 'claim', sort)

            const claims: any[] = []

            res.response.data.forEach((claim: any) => {
                claims.push(claim.fieldData)
            })

            store.commit('setClaimList', claims.filter((c: any) => c.contractNumberDisplay === contract.value.contractNumberDisplay))
        }
        catch (error: any) {
            console.error(error)
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_loading = _resolveComponent("loading")!

  return (isLoading.value)
    ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass([(activeTab.value === 'contract' ? 'bg-white' : 'bg-capGrey bg-opacity-10'), "rounded-t-lg shadow px-8 py-4 text-capPurple cursor-pointer"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleTabs('contract')))
          }, _hoisted_4, 2),
          _createElementVNode("div", {
            class: _normalizeClass([(activeTab.value === 'payments' ? 'bg-white' : 'bg-capGrey bg-opacity-10'), "rounded-t-lg shadow px-8 py-4 text-capPurple cursor-pointer"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTabs('payments')))
          }, " Payments ", 2),
          _createElementVNode("div", {
            class: _normalizeClass([(activeTab.value === 'claims' ? 'bg-white' : 'bg-capGrey bg-opacity-10'), "rounded-t-lg shadow px-8 py-4 text-capPurple cursor-pointer"]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleTabs('claims')))
          }, " Claims ", 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createVNode(ContractInfo, {
            id: props.id
          }, null, 8, ["id"])
        ], 512), [
          [_vShow, activeTab.value === 'contract']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createVNode(ContractPayments, {
            id: props.id
          }, null, 8, ["id"])
        ], 512), [
          [_vShow, activeTab.value === 'payments']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(ContractClaims, {
            id: props.id
          }, null, 8, ["id"])
        ], 512), [
          [_vShow, activeTab.value === 'claims']
        ])
      ]))
}
}

})